import { IOfferHandler } from '../../types';
import { Offer } from '../../../../services/exports/Interfaces';
import { CompleteBasketItem } from '../../../../providers/BasketProvider';
import { useTranslation } from 'react-i18next';

const usePercentageOffByProducts: IOfferHandler = () => {
  const { t } = useTranslation(null, { keyPrefix: 'Features:Offers:OfferBadge' });
  const isUnlocked = (offer: Offer, items: CompleteBasketItem[]) =>
    items.some((item) => offer.details.products.includes(item.entry.id));
  const isEligibleItem = (offer: Offer, item: CompleteBasketItem) => offer.details.products.includes(item.entry.id);
  const getProfit = (offer: Offer, items: CompleteBasketItem[]) =>
    items
      .filter((item) => offer.details.products.includes(item.product_id))
      .reduce((acc, item) => acc + item.entry.actual_price * item.quantity, 0) *
    (offer.details.percentage_amount / 100);
  const apply =
    (offer: Offer) =>
    (item: CompleteBasketItem): CompleteBasketItem => {
      if (!item.actual_price) {
        return item;
      }

      if (item.is_free) {
        return item;
      }

      if (!isEligibleItem(offer, item)) {
        return item;
      }

      const actualPrice =
        item.actual_price - item.entry.actual_price * item.quantity * (offer.details.percentage_amount / 100);

      return {
        ...item,
        badges: [...item.badges, t(offer.kind, { percentageAmount: offer.details.percentage_amount })],
        actual_price: actualPrice,
      };
    };

  return (offer, items) => ({
    isEligible: isUnlocked(offer, items),
    isUnlocked: isUnlocked(offer, items),
    profit: getProfit(offer, items),
    apply: apply(offer),
  });
};

export default usePercentageOffByProducts;
